<template>
  <div class="hero-section">
    <div class="hero-inner">
      <!-- 上半部分：文案 + 主图 -->
      <div class="hero-top">
        <img class="bj-img" src="@/assets/img/images/home/head-bj.png" />
        <div class="hero-content">
          <p class="p1">— {{ $t("home.v2.hero.tag") }}</p>
          <p class="p2">{{ $t("home.v2.hero.title1") }}</p>
          <p class="p3">{{ $t("home.v2.hero.title2") }}</p>
          <p class="p3" v-if="$t('home.v2.hero.title3')">
            {{ $t("home.v2.hero.title3") }}
          </p>
          <p class="p4">
            {{ $t("home.v2.hero.desc") }}
          </p>
          <div class="hero-btns">
            <div class="btn btn-primary" @click="openExternal('https://about.rwa.ltd/consumer-rwa.html')">
              {{ $t("home.v2.hero.btn1") }}
              <img
                class="btn-arrow"
                src="@/assets/img/images/home/group-11630.png"
                alt="arrow"
              />
            </div>
            <div class="btn btn-plain" @click="$emit('play-film')">
              <img
                class="play-icon"
                src="@/assets/img/images/home/group-11036.png"
                alt="play"
              />
              {{ $t("home.v2.hero.btn2") }}
            </div>
          </div>
          <div class="hero-tags">
            <span class="tag-item">
              <img src="@/assets/img/images/home/group-11625.png" alt="tag1" />
              {{ $t("home.v2.hero.tag1") }}
            </span>
            <span class="tag-item">
              <img src="@/assets/img/images/home/group-11624.png" alt="tag2" />
              {{ $t("home.v2.hero.tag2") }}
            </span>
            <span class="tag-item">
              <img src="@/assets/img/images/home/group-11623.png" alt="tag3" />
              {{ $t("home.v2.hero.tag3") }}
            </span>
          </div>
        </div>
      </div>

      <!-- 下半部分：促销卡片 Swiper -->
      <div class="banner-row-wrap">
        <BannerSwiper
          v-if="banners.length > 0"
          :list="banners"
          :page-size="4"
          @item-click="handleBannerClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BannerSwiper from "@/components/Carousel/BannerSwiper";

export default {
  name: "HeroSection",
  components: {
    BannerSwiper,
  },
  data() {
    return {
      banners: [],
    };
  },
  computed: {
    // 简体/繁体中文使用中文图，其余语言使用英文图（与原静态图逻辑一致）
    isZh() {
      const lan = this.$i18n.locale || "";
      return lan.indexOf("zh") === 0;
    },
    // 4 条内置测试 Banner（固定放在接口数据前面）
    defaultBanners() {
      const suffix = this.isZh ? "zh" : "en";
      return [1, 2, 3, 4].map((i) => ({
        id: "default-" + i,
        image: require("@/assets/img/images/home/head" +
          i +
          "-" +
          suffix +
          ".png"),
        jumpUrl: "/mall",
        absoluteUrl: false,
      }));
    },
  },
  created() {
    this.getBannerList();
  },
  methods: {
    // 从 CMS 接口获取 Banner 列表，与内置 4 条测试数据合并
    getBannerList() {
      this.$axios
        .post("/cms/getList", {
          page: 1,
          rows: 10,
          cateCode: "banner",
        })
        .then((res) => {
          const apiList = res.data.data.rows || [];
          // 内置测试数据在前，接口数据追加在后面
          // this.banners = [...this.defaultBanners, ...apiList];
		  this.banners = apiList;
        })
        .catch(() => {
          // 接口失败时只显示内置测试数据
          // this.banners = [...this.defaultBanners];
        });
    },
    // Banner 卡片点击：参照 VCarousel 逻辑，优先 articleId → 详情页；否则按 jumpUrl 跳转
    handleBannerClick(item) {
      // 接口返回的 banner 若带 articleId → 跳转新闻详情（与 VCarousel.itemClick 一致）
      if (item.articleId) {
        this.$router.push({
          path: "/newsDetail",
          query: { id: item.articleId },
        });
        return;
      }
      // 静态默认 banner 或带 jumpUrl 的 banner
      const url = item.jumpUrl;
      if (!url) return;
      if (item.absoluteUrl) {
        window.open(url);
      } else {
        this.$router.push(url);
      }
    },
    // 新窗口打开外部链接
    openExternal(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.hero-section {
  width: 100%;
  height: 1021px;
  box-sizing: border-box;
  padding: 0 26px 0 60px;
  background: #ffffff;
}
.hero-inner {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.hero-top {
  position: relative;
  box-sizing: border-box;
  .bj-img {
    position: absolute;
    width: 1066px;
    height: 582px;
    top: 40px;
    right: 0;
    z-index: 1;
  }
  .hero-content {
    padding-top: 106px;
    position: relative;
    box-sizing: border-box;
    z-index: 2;
    max-width: 900px;
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
    }
    .p2 {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: clamp(32px, 2.75vw, 60px);
      line-height: 1.35;
      color: #333333;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    .p3 {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: bold;
      font-size: clamp(32px, 2.75vw, 60px);
      line-height: 1.35;
      color: #E05807;
      margin-top: -8px;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    .p4 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #333333;
      margin-top: 16px;
      width: 720px;
    }
    .hero-btns {
      display: flex;
      align-items: center;
      gap: 24px;
      margin-top: 48px;
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 56px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        transition: all 0.2s;
      }
      .btn-primary {
        padding: 0 32px;
        color: #ffffff;
        background: #E05807;
        border-radius: 8px 8px 8px 8px;
        .btn-arrow {
          width: 16px;
          height: 16px;
          margin-left: 12px;
        }
        &:hover {
          background: #a02b2d;
        }
      }
      .btn-plain {
        color: #333333;
        .play-icon {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
    .hero-tags {
      display: flex;
      align-items: center;
      gap: 40px;
      margin-top: 48px;
      .tag-item {
        display: flex;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
}

.banner-row-wrap {
  margin-top: 50px;
  margin-bottom: 40px;
}
</style>
